// Description: function to change the profile Image of the user
// Updated: 08/09/2025
// Author: Simon Franklin

import { getTokenData } from "../../../shared/utils/utils";

export const ChangeProfileImage = async (newImage) => {
    try {
        const { token, client_id } = await getTokenData();

        if (!token) throw new Error('Token de autenticação não encontrado');

        if (!client_id) throw new Error('ID do cliente não encontrado');

        const res = await fetch(`${process.env.REACT_APP_BACKEND_AWS_URL}/profile/avatar`, {
            body: JSON.stringify({ base64_image: newImage }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${token}`,
                'Client_ID': `${client_id}`
            },
            method: 'PUT'
        });

        const data = await res.json();

        return data;
    } catch (error) {
        return error.message;
    }
}